import {
  SetDefaultData,
  UpdateField,
  FetchPdfBatchStatsRequest,
  FetchPdfBatchTaskStatusRequest,
  GeneratePdfBatchRequest,
  StopPdfBatchGenerationRequest,
} from './pdf-batch-generation.actions'
import { getPdfBatchGenerationState } from './pdf-batch-generation.selectors'
import Validator from '@shared/validatorjs/src/validator'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Map, List } from 'immutable'
import { Subscription } from 'rxjs'
import { isContentEditableEnabled } from '@containers/i18n/store/i18n.selector'

@Component({
  selector: 'app-pdf-batch-generation',
  templateUrl: './pdf-batch-generation.component.html',
  styleUrls: ['./pdf-batch-generation.component.css'],
})
export class PdfBatchGenerationComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public isStatsLoading: boolean
  private state$: Subscription
  private batchTaskStatus$: any
  public stats: any[] = []
  public statusTimeout: any
  public statusInterval: any
  public isNotRunningCount = 0
  public isLoading = false
  public isTranslationActive: boolean
  public isTranslationActive$: Subscription

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('settings'))

    this.isTranslationActive$ = this.store
      .pipe(select(isContentEditableEnabled))
      .subscribe((isTranslationActive) => {
        this.isTranslationActive = isTranslationActive
      })

    this.state$ = this.store
      .pipe(select(getPdfBatchGenerationState))
      .subscribe((state) => {
        this.state = state
        this.stats = state.get('stats').toJS()
        this.isLoading = state.get('isLoading')
        this.isStatsLoading = state.get('isStatsLoading')
      })

    this.store.dispatch<any>(new FetchPdfBatchStatsRequest())
    this.store.dispatch<any>(new FetchPdfBatchTaskStatusRequest())

    setTimeout(() => {
      this.batchTaskStatus$ = setInterval(() => {
        if (!this.isTranslationActive) {
          this.store.dispatch<any>(new FetchPdfBatchTaskStatusRequest())
        }
      }, 2000)
    }, 2000)
  }

  checkIfRunning() {
    return this.stats.reduce(
      (prev, stat) => prev || stat.state.name === 'RUNNING',
      false,
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.isTranslationActive$.unsubscribe()
    clearInterval(this.batchTaskStatus$)
  }

  public start() {
    this.store.dispatch<any>(new GeneratePdfBatchRequest())
  }
  public stop() {
    this.store.dispatch<any>(new StopPdfBatchGenerationRequest())
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {}
    const validator = new Validator(data.toJS(), rules)

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      // this.store.dispatch(new UpdateSettingsRequest(this.userId, payload));
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
